module.exports = __webpack_public_path__ + "static/media/this-is-sam-francis.46e1c3b9.txt";